import React from "react";
import { default as MuiRating } from "@mui/material/Rating";

function Rating(props) {
  return <MuiRating {...props} />;
}

export default Rating;
